var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"breadcrumbsItems":_vm.items,"title":'Instructivos y Tutoriales'}}),_c('v-row',_vm._l((_vm.apps),function(app,i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"4"}},[_c('AppDescarga',{attrs:{"title":app.title,"videoId":app.videoId,"text":app.text}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }